"use client";

import { createElement, useEffect } from "react";
import { ZAPIER_CLIENT_ID } from "@/lib/content/integrations/config";

const SCRIPT_SRC =
  "https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js";
const STYLE_HREF =
  "https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css";

export default function ZapierExperience() {
  useEffect(() => {
    if (!document.querySelector(`link[href="${STYLE_HREF}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = STYLE_HREF;
      document.head.appendChild(link);
    }

    if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      const script = document.createElement("script");
      script.type = "module";
      script.src = SCRIPT_SRC;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div className="max-w-full overflow-hidden">
      {createElement("zapier-full-experience", {
        "client-id": ZAPIER_CLIENT_ID,
        theme: "light",
        "intro-copy-display": "show",
        "app-search-bar-display": "show",
        "app-limit": "10",
        "app-categories":
          "ecommerce,email,wordpress,communication,spreadsheets",
        "zap-limit": "10",
        "zap-style": "card",
        "zap-create-from-scratch-display": "show",
      })}
    </div>
  );
}
